import { render, staticRenderFns } from "./SelectFaceModal.vue?vue&type=template&id=a1dff960&scoped=true&"
import script from "./SelectFaceModal.vue?vue&type=script&lang=js&"
export * from "./SelectFaceModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectFaceModal.vue?vue&type=style&index=0&id=a1dff960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dff960",
  null
  
)

export default component.exports